import * as React from 'react';
import { Col, Modal, Row, Input } from 'antd';
import Form, { FormItem } from '../../../components/Form';
import { ICreateNonProductOrderItem } from 'data-layer/src/services/OrderItems/interfaces/ICreateOrderItem';

interface ICreateNonProductOrderItemEditorProps {
  order: GQL.IOrder;
  onCreate: (data: ICreateNonProductOrderItem) => void;
  onCancel: () => void;
}

interface ICreateNonProductOrderItemEditorState {
  data: {
    title: string | undefined;
    name: any;
    recommendedPrice?: number;
    price: number;
    sku: string;
    quantity: number;
  };
}

export default class CreateNonProductOrderItemEditor extends React.Component<ICreateNonProductOrderItemEditorProps, ICreateNonProductOrderItemEditorState> {

  private form;

  constructor(props: ICreateNonProductOrderItemEditorProps) {
    super(props);

    this.state = {
      data: {
        title: '',
        name: {},
        recommendedPrice: undefined,
        price: 0,
        sku: '',
        quantity: 1,
      },
    };

    this.form = React.createRef;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public render() {
    const { order } = this.props;

    const languageCode = order.language;

    return (
      <Modal
        title={'New order item'}
        visible={true}
        maskClosable={false}
        cancelText={'Cancel'}
        okText={'Create'}
        onOk={this.onSubmit}
        onCancel={() => this.props.onCancel()}
      >
        <Row>
          <Col span={24}>
            <Form
              ref={f => this.form = f}
              displayFooter={false}
              onSubmit={this.onSubmit}
              onCancel={() => this.props.onCancel()}
            >
              <FormItem label={'Title'} required={true}>
                <Input
                  name={'title'}
                  placeholder="Title"
                  value={this.state.data.title}
                  required={true}
                  autoFocus={true}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Name'} required={true}>
                <Input
                  name={'name'}
                  placeholder="Name"
                  addonBefore={languageCode}
                  value={this.state.data.name[languageCode]}
                  onChange={(e: any) => this.onChange(e, e.target.value, languageCode)}
                />
              </FormItem>
              <FormItem label={'Code'}>
                <Input
                  name={'sku'}
                  placeholder="Code"
                  value={this.state.data.sku}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Item recommended price (incl. Vat)'}>
                <Input
                  type={'number'}
                  name={'recommendedPrice'}
                  step={'0.01'}
                  addonAfter={order.currency ? order.currency.value : undefined}
                  placeholder="Recommended price"
                  value={this.state.data.recommendedPrice}
                  onChange={e => this.onChange(e, parseFloat(e.target.value))}
                />
              </FormItem>
              <FormItem label={'Item price (incl. Vat)'} required={true}>
                <Input
                  type={'number'}
                  name={'price'}
                  step={'0.01'}
                  addonAfter={order.currency ? order.currency.value : undefined}
                  placeholder="Price"
                  value={this.state.data.price}
                  required={true}
                  onChange={e => this.onChange(e, parseFloat(e.target.value))}
                />
              </FormItem>
              <FormItem label={'Quantity'} required={true}>
                <Input
                  type={'number'}
                  name={'quantity'}
                  placeholder="Quantity"
                  value={this.state.data.quantity}
                  required={true}
                  onChange={e => this.onChange(e, parseInt(e.target.value))}
                />
              </FormItem>
            </Form>
          </Col>
        </Row>
      </Modal>
    );
  }

  private onChange(e: any, val: any = null, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = val ? val : (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state.data[name], [language]: inputValue } }
      : { [name]: inputValue });

    this.setState({
      data: {...this.state.data, ...newValue},
    });
  }

  private async onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onCreate({...this.state.data} as ICreateNonProductOrderItem);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/OrderItems/OrderItemsEditors/CreateNonProductOrderItemEditor.tsx